<!-- ══════════════════════════════════════════════════════════════
Encabezado
═══════════════════════════════════════════════════════════════ -->
<app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

<!-- ══════════════════════════════════════════════════════════════
Buscador + Tabla
═══════════════════════════════════════════════════════════════ -->
<div class="table-section">

  <div class="filter-bar filter-bar--flush">
    <div class="filter-card">
      <app-search-pill [value]="searchText()" placeholder="Nombre o descripción…" (search)="onSearch($event)"></app-search-pill>
      <mat-button-toggle-group class="view-toggle" [value]="listView.mode" (change)="listView.set($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
      <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
      <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
    </mat-button-toggle-group>
    </div>
    <app-filter-chips [count]="dataSource.filteredData.length" [total]="dataSource.data.length" noun="permisos"></app-filter-chips>
  </div>

  <div class="list-actions">
    <button mat-stroked-button (click)="pageLoad.refresh(loadPermissions())"><mat-icon>refresh</mat-icon> Actualizar</button>
    <button mat-flat-button color="primary" (click)="openCreate()">
        <mat-icon>add</mat-icon> Nuevo Permiso
      </button>
  </div>

  <app-selection-bar [count]="sel.count" (export)="exportExcel(sel.selected)" (clear)="sel.clear()"></app-selection-bar>

  <mat-paginator [hidden]="listView.mode !== 'table'" [pageSize]="10" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>

  @if (loading()) {
    <div class="loading-row">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Cargando permisos...</span>
    </div>
  }


  @if (listView.mode === 'cards') {
    <div class="inv-cards cat-cards">
      @for (p of dataSource.filteredData; track $index) {
        <div class="cat-card" [class.cat-card--selected]="sel.isSelected(p)">
          <div class="cat-card__head">
            <mat-checkbox color="primary" [checked]="sel.isSelected(p)" (change)="sel.toggle(p)" matTooltip="Seleccionar"></mat-checkbox>
            <mat-icon class="perm-icon">verified_user</mat-icon>
            <span class="cat-card__title">{{ p.name }}</span>
          </div>
          <div class="cat-card__body">
            <div class="cat-card__field"><span class="cat-card__label">Descripción:</span><span class="cat-card__value">{{ p.description || '—' }}</span></div>
          </div>
          <div class="cat-card__actions">
            <mat-slide-toggle [checked]="p.active" (change)="toggleActive(p)" color="primary" [matTooltip]="p.active ? 'Activo — click para desactivar' : 'Inactivo — click para activar'"></mat-slide-toggle>
            <span class="spacer"></span>
            <button mat-icon-button color="primary" matTooltip="Editar" (click)="openEdit(p)"><mat-icon>edit</mat-icon></button>
          </div>
        </div>
      }
      @if (dataSource.filteredData.length === 0) {
        <p class="inv-cards__empty">Sin resultados</p>
      }
    </div>
  }

  <div class="table-container mat-elevation-z2" [hidden]="listView.mode !== 'table'">
    <table mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="select-cell">
          <mat-checkbox color="primary" (change)="$event ? sel.toggleAll() : null" [checked]="sel.allSelected()" [indeterminate]="sel.someSelected()" matTooltip="Seleccionar todos los visibles"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="select-cell">
          <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="$event ? sel.toggle(row) : null" [checked]="sel.isSelected(row)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let p">
          <div class="name-cell">
            <mat-icon class="perm-icon">verified_user</mat-icon>
            <span class="name">{{ p.name }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Descripción</th>
        <td mat-cell *matCellDef="let p">{{ p.description || '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let p">
          <mat-slide-toggle
            [checked]="p.active"
            (change)="toggleActive(p)"
            color="primary"
            [matTooltip]="p.active ? 'Activo — click para desactivar' : 'Inactivo — click para activar'">
          </mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let p">
          <button mat-icon-button color="primary" matTooltip="Editar"
            (click)="openEdit(p)">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;" class="table-row"></tr>

      <tr class="no-data-row" *matNoDataRow>
        <td [attr.colspan]="columns.length">
          <div class="no-data">
            <mat-icon>search_off</mat-icon>
            <span>No se encontraron permisos</span>
          </div>
        </td>
      </tr>
    </table>
  </div>


</div>